import{ERROR_INVENTORIES}from"../constants";/**
 * Dispatches the ERROR_PRODUCT_INVENTORIES action object.
 * @param {string} productId The ID of the product.
 * @param {Array} locationCodes List of location codes.
 * @param {Error} error error
 * @return {Object} The ERROR_PRODUCT_LOCATIONS action.
 */var errorInventories=function errorInventories(productId,locationCodes,error){return{type:ERROR_INVENTORIES,productId:productId,locationCodes:locationCodes,error:error};};export default errorInventories;